var map = {
	"./clock.svg": "e10c",
	"./data.svg": "95e5",
	"./doctor.svg": "caa9",
	"./facebook.svg": "e228",
	"./handshake-white.svg": "6b87",
	"./handshake.svg": "908d",
	"./hospital.svg": "6a50",
	"./hospital1.svg": "4b89",
	"./idea.svg": "bff1",
	"./info.svg": "30b1",
	"./innovation.svg": "7be3",
	"./layers.svg": "5c3e",
	"./line.svg": "914f",
	"./map.svg": "c925",
	"./messenge.svg": "19d1",
	"./messengeCard.svg": "c8ed",
	"./microscop-white.svg": "7372",
	"./microscop.svg": "e117",
	"./network.svg": "6065",
	"./phone.svg": "db97",
	"./physics.svg": "0bae",
	"./profit.svg": "8719",
	"./quality.svg": "97e1",
	"./regis_news.svg": "4259",
	"./regis_schedule.svg": "cfeb",
	"./regis_search.svg": "729b",
	"./right_arrow.svg": "7c88",
	"./search.svg": "a32f",
	"./seemap.svg": "f95b",
	"./user-gray.svg": "d3b2",
	"./user-white.svg": "b18a",
	"./user.svg": "4c86",
	"./website.svg": "204d",
	"./welfare.svg": "9b21",
	"./youtube.svg": "a1db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef8d";